var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7679 3.56526H2.65449C2.46634 3.56526 2.31395 3.42139 2.31395 3.24376C2.31395 3.06613 2.46634 2.92225 2.65449 2.92225H10.8275C11.0156 2.92225 11.168 2.77838 11.168 2.60075C11.168 2.06805 10.7106 1.63623 10.1464 1.63623H2.31395C1.56156 1.63623 0.951782 2.21193 0.951782 2.92225V9.35234C0.951782 10.0627 1.56156 10.6384 2.31395 10.6384H10.7679C11.3642 10.6384 11.8491 10.2057 11.8491 9.67384V4.52977C11.8491 3.99789 11.3642 3.56526 10.7679 3.56526ZM9.80584 7.74482C9.42976 7.74482 9.12476 7.45687 9.12476 7.10181C9.12476 6.74675 9.42976 6.4588 9.80584 6.4588C10.1819 6.4588 10.4869 6.74675 10.4869 7.10181C10.4869 7.45687 10.1819 7.74482 9.80584 7.74482Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.be73d135e4632c6df5ccd4b260a2e15c.svg";
export { ForwardRef as ReactComponent };